import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';

const API = process.env.REACT_APP_BACKEND_URL || '';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // FoundryAI SSO — session_id may arrive in the URL hash or query string.
        const hash = window.location.hash || '';
        const search = window.location.search || '';
        const params = new URLSearchParams(
          (hash.startsWith('#') ? hash.slice(1) : hash) || search
        );
        const sessionId = params.get('session_id');
        if (sessionId) {
          const res = await fetch(`${API}/api/auth/sso/callback`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ session_id: sessionId }),
          });
          if (res.ok) {
            const data = await res.json();
            if (data?.token) localStorage.setItem('token', data.token);
            if (data?.user_id) localStorage.setItem('user_id', data.user_id);
          } else {
            console.error('[foundryai-sso] callback failed', res.status, await res.text());
          }
        }
      } catch (err) {
        console.error('[foundryai-sso] callback error', err);
      }
      // Native GitHub / Google OAuth also lands here — cookie already set by backend.
      await checkAuth();
      navigate('/', { replace: true });
    };
    handleCallback();
  }, [navigate, checkAuth]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="spinner" />
    </div>
  );
}
